import { occupancyTone } from "@/lib/format";

export default function OccupancyBar({ current = 0, approved = 0, size = "md" }) {
  const pct = approved > 0 ? Math.min(200, (current / approved) * 100) : 0;
  const tone = occupancyTone(pct);
  const width = Math.min(100, pct);
  return (
    <div className="w-full">
      <div className="flex items-center justify-between text-[11.5px] font-medium">
        <span className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 ring-1 ring-inset ${tone.bg} ${tone.text} ${tone.ring}`}>
          <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: tone.color }} />
          {tone.label}
        </span>
        <span className="tabular-nums text-muted-foreground">
          {current}/{approved || 0} · {pct.toFixed(0)}%
        </span>
      </div>
      <div className={`rh-bar mt-1.5 ${size === "sm" ? "h-1.5" : "h-2"}`}>
        <span style={{ width: `${width}%`, backgroundColor: tone.color }} />
      </div>
      {pct > 100 && (
        <div className="mt-1 text-[11px] font-medium text-red-600">
          Excesso de {current - approved} colaborador(es) acima do quadro aprovado
        </div>
      )}
    </div>
  );
}
